import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../lib/api";
import { useMe } from "./useMe";
import { resolveMembership } from "./useFamilyMembership";
import { can } from "@family/shared";

interface PendingUsersResponse {
  users: unknown[];
}

/**
 * Number of users waiting for approval, for approvers (admin/moderator);
 * 0 for everyone else. Shares the ["pending-users", slug] cache key with
 * MembersPage, so approving/denying there updates badges immediately.
 */
export function usePendingCount(): number {
  const meQuery = useMe();
  const membership = resolveMembership(meQuery.data);
  const canApprove = membership
    ? can(membership.role, "members:approve")
    : false;

  const query = useQuery<PendingUsersResponse>({
    queryKey: ["pending-users", membership?.familySlug],
    queryFn: () =>
      apiFetch<PendingUsersResponse>(
        `/families/${membership!.familySlug}/members/pending`,
      ),
    enabled: canApprove,
    staleTime: 60_000,
  });

  return query.data?.users.length ?? 0;
}
